import ZKeyIndicator from './ZKeyIndicator.vue'

export default ZKeyIndicator
